const rankingItems = [
  { rank: 1, title: '秘密恋爱', genre: '校园恋爱', heat: '🔥 9.8', desc: '青梅竹马重逢后的心动校园物语，画风细腻唯美，连续12周霸榜第一', change: 'up' as const },
  { rank: 2, title: '剑与魔法', genre: '奇幻冒险', heat: '🔥 9.6', desc: '异世界转生题材新标杆，战斗场面张力十足，世界观构建宏大', change: 'up' as const },
  { rank: 3, title: '暗夜追凶', genre: '悬疑推理', heat: '🔥 9.5', desc: '连环凶案背后的惊人真相，每话反转不断，读者讨论热度持续飙升', change: 'new' as const },
  { rank: 4, title: '职场生存记', genre: '都市职场', heat: '🔥 9.3', desc: '新人社员的爆笑成长日记，真实还原韩国职场生态，引发广泛共鸣', change: 'down' as const },
  { rank: 5, title: '恶役千金物语', genre: '恋爱奇幻', heat: '🔥 9.2', desc: '转生为反派千金的逆袭之路，甜虐交织，人气急速攀升中', change: 'up' as const },
];

const changeIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-secondary-500',
  new: 'ri-sparkling-line text-accent-500',
};

const changeLabel: Record<string, string> = {
  up: '上升',
  down: '下降',
  new: '新进',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">韩漫热度排行</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            基于阅读量、讨论度与收藏数综合计算，每周更新热门韩漫榜单
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200/60 transition-colors group"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700 font-heading text-lg md:text-xl font-bold">
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.genre}
                  </span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{item.heat}</span>
                <span className={`flex items-center gap-0.5 text-xs ${changeIcon[item.change].split(' ')[1]}`}>
                  <i className={changeIcon[item.change]}></i>
                  {changeLabel[item.change]}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}